import { appClient } from 'api/apiClient';
import { buildPageQuery, type Paginated } from 'api/v1Helpers';
import type { LedgerEntryRow, ReportSummary, ReportsDateRange } from 'types/reports';

/** GET /v1/parishes/:parishId/transactions — parish ledger feed (CLERK+, paginated). */
export async function fetchTransactions(
    parishId: string,
    opts?: { page?: number; pageSize?: number } & ReportsDateRange
): Promise<Paginated<LedgerEntryRow>> {
    const params = buildPageQuery(opts?.page ?? 1, opts?.pageSize ?? 20, {
        from: opts?.from,
        to: opts?.to,
    });
    const res = await appClient.get<Paginated<LedgerEntryRow>>(`parishes/${parishId}/transactions?${params.toString()}`);
    return {
        items: res.items || [],
        total: res.total ?? (res.items || []).length,
        page: res.page ?? opts?.page ?? 1,
        pageSize: res.pageSize ?? opts?.pageSize ?? 20,
    };
}

/** GET /v1/parishes/:parishId/reports/summary — aggregate ledger totals (MERCHANT_ADMIN+). */
export async function fetchReportSummary(parishId: string, opts?: ReportsDateRange): Promise<ReportSummary> {
    const params = new URLSearchParams();
    if (opts?.from) params.set('from', opts.from);
    if (opts?.to) params.set('to', opts.to);
    const qs = params.toString();
    return appClient.get<ReportSummary>(`parishes/${parishId}/reports/summary${qs ? `?${qs}` : ''}`);
}
